import { api } from "@/frontend/services/api";
import type {
  PaginationRequestDTO,
  TournamentParticipantResponseDTO,
  TournamentParticipantsPaginatedResponseDTO,
  TournamentParticipantQueryDTO,
  CreateTournamentParticipantRequestDTO,
  UpdateTournamentParticipantRequestDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/tournament-participants/private";

export const tournamentParticipantService = {
  getPaginate: (params?: Partial<PaginationRequestDTO & TournamentParticipantQueryDTO>) =>
    api.getWithParams<ApiResponse<TournamentParticipantsPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id: string) =>
    api.get<ApiResponse<TournamentParticipantResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateTournamentParticipantRequestDTO) =>
    api.post<ApiResponse<TournamentParticipantResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateTournamentParticipantRequestDTO) =>
    api.put<ApiResponse<TournamentParticipantResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
  getAll: async (
    params: Partial<TournamentParticipantQueryDTO>,
  ): Promise<TournamentParticipantResponseDTO[]> => {
    const pageSize = 100;
    let page = 1;
    const all: TournamentParticipantResponseDTO[] = [];

    while (true) {
      const res = await api.getWithParams<ApiResponse<TournamentParticipantsPaginatedResponseDTO>>(
        BASE_URL,
        { ...params, page, pageSize },
      );
      if (!res.success || !res.data) break;

      all.push(...res.data.data);
      if (res.data.data.length < pageSize) break;
      page += 1;
    }

    return all;
  },
};
